var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { ref: "handleItemForm", attrs: { model: _vm.handleItem } },
    [
      !_vm.fiscalHandle
        ? _c(
            "div",
            { staticClass: "simple-form" },
            [
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("处理方式")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-2x" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "wayValue",
                          rules: { validator: _vm.checkNull, trigger: "blur" }
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            on: { change: _vm.clearTheOtherInfo },
                            model: {
                              value: _vm.handleItem.wayValue,
                              callback: function($$v) {
                                _vm.$set(_vm.handleItem, "wayValue", $$v)
                              },
                              expression: "handleItem.wayValue"
                            }
                          },
                          _vm._l(_vm.assetCheckHandleWayEnumList, function(
                            item
                          ) {
                            return _c("el-option", {
                              attrs: { label: item.text, value: item.value }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("处理数量")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-2x" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "quantity",
                          rules: {
                            validator: _vm.checkQuantity,
                            trigger: "blur"
                          }
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.handleItem.quantity,
                              expression: "handleItem.quantity"
                            }
                          ],
                          staticClass: "align-right",
                          attrs: {
                            type: "number",
                            disabled: _vm.batch != null && _vm.batch,
                            min: 1,
                            max: _vm.voucherItem.allowQuantity
                          },
                          domProps: { value: _vm.handleItem.quantity },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.handleItem,
                                "quantity",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.handleItem.wayValue == -3
                ? _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("清除原因")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value width-2x" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "clearCause" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择清除原因" },
                                model: {
                                  value: _vm.handleItem.clearCause,
                                  callback: function($$v) {
                                    _vm.$set(_vm.handleItem, "clearCause", $$v)
                                  },
                                  expression: "handleItem.clearCause"
                                }
                              },
                              _vm._l(_vm.devcClearCauseEnumList, function(
                                item
                              ) {
                                return _c("el-option", {
                                  attrs: { label: item.text, value: item.value }
                                })
                              })
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.handleItem.wayValue == 2 || _vm.handleItem.wayValue == -2
                ? [
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v("跨机构调拨")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.clearTheOtherInfo },
                                  model: {
                                    value: _vm.transComFlag,
                                    callback: function($$v) {
                                      _vm.transComFlag = $$v
                                    },
                                    expression: "transComFlag"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("是")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("否")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.transComFlag
                      ? _c("div", { staticClass: "form-group center" }, [
                          _c("div", { staticClass: "form-label" }, [
                            _vm.handleItem.wayValue == 2
                              ? _c("label", [_vm._v("调出机构")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.handleItem.wayValue == -2
                              ? _c("label", [_vm._v("调入机构")])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-value width-2x" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "theOtherComName" } },
                                [
                                  _c("el-input", {
                                    staticClass: "bottom-line width-1-5x",
                                    attrs: { disabled: true },
                                    model: {
                                      value: _vm.handleItem.theOtherComName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.handleItem,
                                          "theOtherComName",
                                          $$v
                                        )
                                      },
                                      expression: "handleItem.theOtherComName"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                                    attrs: { title: "选择机构" },
                                    on: {
                                      click: function($event) {
                                        _vm.showOrgSelectDlg()
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.transComFlag
                      ? _c("div", { staticClass: "form-group center" }, [
                          _c("div", { staticClass: "form-label" }, [
                            _vm.handleItem.wayValue == 2
                              ? _c("label", [_vm._v("调出仓库")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.handleItem.wayValue == -2
                              ? _c("label", [_vm._v("调入仓库")])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-value width-2x" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "theOtherWarehouseId" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请选择仓库"
                                      },
                                      on: { change: _vm.compareIn },
                                      model: {
                                        value:
                                          _vm.handleItem.theOtherWarehouseId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.handleItem,
                                            "theOtherWarehouseId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "handleItem.theOtherWarehouseId"
                                      }
                                    },
                                    _vm._l(_vm.warehouseList, function(item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id
                                        }
                                      })
                                    })
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fiscalHandle
        ? _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("处理方式")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "fiscalWayValue",
                        rules: { validator: _vm.checkNull, trigger: "blur" }
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.handleItem.fiscalWayValue,
                            callback: function($$v) {
                              _vm.$set(_vm.handleItem, "fiscalWayValue", $$v)
                            },
                            expression: "handleItem.fiscalWayValue"
                          }
                        },
                        _vm._l(_vm.assetCheckHandleWayEnumList, function(item) {
                          return _c("el-option", {
                            attrs: { label: item.text, value: item.value }
                          })
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("处理数量")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "fiscalQuantity",
                        rules: {
                          validator: _vm.checkFiscalQuantity,
                          trigger: "blur"
                        }
                      }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.handleItem.fiscalQuantity,
                            expression: "handleItem.fiscalQuantity"
                          }
                        ],
                        staticClass: "align-right",
                        attrs: { type: "number", min: 1 },
                        domProps: { value: _vm.handleItem.fiscalQuantity },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.handleItem,
                              "fiscalQuantity",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("处理说明")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "fiscalComment" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.handleItem.fiscalComment,
                          callback: function($$v) {
                            _vm.$set(_vm.handleItem, "fiscalComment", $$v)
                          },
                          expression: "handleItem.fiscalComment"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a12c938", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a12c938","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceStockHandleItemSave.vue
// module id = 3218
// module chunks = 0